/**
 * node_modules
 */
import React from "react"
import { getImage } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby"
import { Link as GatsbyLink } from "gatsby-link"

/**
 * hooks
 */
import { useViewportHeight } from "@hooks/use-viewport-height"

/**
 * styles
 */
import * as styles from "@features/Home/Hero/Hero.module.scss"

/**
 * components
 */
import { ResponsiveImage } from "@components/ResponsiveImage"
import { HomeHeroTextDesktop, HomeHeroTextMobile } from "@svg/Svg"

/**
 * Modules
 */
import { News } from "@features/Home/News"

/**
 * @function Hero
 * @description HOME/Heroセクション
 */
export const Hero = () => {
  const data: Queries.HomeHeroDataQuery = useStaticQuery(graphql`
    query HomeHeroData {
      heroTextMobile: file(relativePath: { eq: "images/home/hero-text.svg" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED, placeholder: NONE)
        }
      }
      heroTextDesktop: file(relativePath: { eq: "images/home/hero-text-desktop.svg" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED, placeholder: NONE)
        }
      }
      heroMobile: file(relativePath: { eq: "images/home/hero.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED, placeholder: NONE)
        }
      }
      heroDesktopImage: file(relativePath: { eq: "images/home/hero-desktop.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED, placeholder: NONE)
        }
      }
    }
  `)

  // Get clientHeight of hero and set it to CSS variable
  useViewportHeight()

  return (
    <div className={styles["fv"]}>
      <div className={styles.hero}>
        <p className={`${styles["hero_heading"]}`}>
          <HomeHeroTextDesktop className={styles["only__pc"]} alt="自然を、自然のままに。" />
          <HomeHeroTextMobile className={styles["only__sp"]} alt="自然を、自然のままに。" />
        </p>
        <ul className={styles["hero_link"]}>
          <li>
            <GatsbyLink to="/tsumagoi" className={`${styles.textLink} ${styles.textRotate}`}>
              <span className={`${styles["hero_link__small"]} ${styles.textRotate_inner}`}>
                <span className={styles["textRotate_text"]}>カンパーニャ</span>
                <span className={styles["textRotate_pseudo"]} aria-hidden="true">
                  カンパーニャ
                </span>
              </span>
              <br className={styles["only__sp"]} />
              <span className={styles.textRotate_inner}>
                <span className={styles["textRotate_text"]}>嬬恋キャンプ場</span>
                <span className={styles["textRotate_pseudo"]} aria-hidden="true">
                  嬬恋キャンプ場
                </span>
              </span>
            </GatsbyLink>
          </li>
          <li>
            <GatsbyLink to="/tsunan" className={`${styles.textLink} ${styles.textRotate}`}>
              <span className={styles["textRotate_text"]}>津南キャンプ場</span>
              <span className={styles["textRotate_pseudo"]} aria-hidden="true">
                津南キャンプ場
              </span>
            </GatsbyLink>
          </li>
          <li>
            <GatsbyLink to="/minaminorikura" className={`${styles.textLink} ${styles.textRotate}`}>
              <span className={styles["textRotate_text"]}>南乗鞍キャンプ場</span>
              <span className={styles["textRotate_pseudo"]} aria-hidden="true">
                南乗鞍キャンプ場
              </span>
            </GatsbyLink>
          </li>
        </ul>
        <div className={styles["hero_img"]}>
          <ResponsiveImage
            mobileImage={getImage(data.heroMobile!.childImageSharp!.gatsbyImageData)}
            desktopImage={getImage(data.heroDesktopImage!.childImageSharp!.gatsbyImageData)}
            noLazy={true}
            className={styles["hero_img_item__inner"]}
            wrapperClassName={styles["hero_img_item"]}
          />
        </div>
      </div>
      <News />
    </div>
  )
}
